import { render, staticRenderFns } from "./AdminPermissionList.vue?vue&type=template&id=154e354c&"
import script from "./AdminPermissionList.vue?vue&type=script&lang=js&"
export * from "./AdminPermissionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports